export const NFTransport = {
    address: "0xC3AAd60552db3Be8CBddB04B2118e446A715620f",
    abi: [
        "function safeMint() returns (bool success)",
        "function redeem(uint256 tokenId) returns (bool success)"
    ],
  };
  